"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _styles = require("../styles");

var _constants = require("./constants");

var _BorrowerFlow = _interopRequireDefault(require("./BorrowerFlow"));

var _EnterpriseAgentFlow = _interopRequireDefault(require("./EnterpriseAgentFlow"));

var _publicClient = _interopRequireDefault(require("./publicClient"));

var _isTokenValid = _interopRequireDefault(require("./isTokenValid.graphql"));

var _client = require("@apollo/client");

var _navigation = require("../utils/navigation");

var _propTypes = _interopRequireDefault(require("prop-types"));

var styles = function styles(theme) {
  return {
    userSignUpFormRoot: (0, _defineProperty2["default"])({
      width: '100%',
      maxWidth: theme.spacing(100)
    }, theme.breakpoints.down('xs'), {
      maxWidth: 'unset'
    }),
    paper: (0, _defineProperty2["default"])({
      marginTop: theme.spacing(4),
      padding: 0
    }, theme.breakpoints.down('xs'), {
      marginTop: theme.spacing(2),
      borderRadius: 0
    }),
    innerPaperContainer: {
      borderRadius: theme.spacing(1)
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var defaultOnError = function defaultOnError(errType, links) {
  console.log({
    errType: errType
  });

  switch (errType) {
    case _constants.ERROR_CODES.HAS_ACCOUNT:
      (0, _navigation.redirect)("".concat(links.loginUrl, "?textType=account_claimed"));
      break;

    case _constants.ERROR_CODES.IS_LOGGED_IN:
      (0, _navigation.redirect)(links.appUrl);
      break;

    case _constants.ERROR_CODES.NEED_NEW_TOKEN:
    case _constants.ERROR_CODES.MISSING_TOKEN:
    case _constants.ERROR_CODES.INVALID_TOKEN:
      // TODO: Error page
      console.log('Needs new token');
      break;

    default:
      break;
  }
};

var defaultOnSuccess = function defaultOnSuccess(links) {
  (0, _navigation.redirect)(links.loginUrl);
};

var UserSignUp = function UserSignUp(_ref) {
  var mode = _ref.mode,
      claimToken = _ref.claimToken,
      isPartnerBorrower = _ref.isPartnerBorrower,
      useFooterLogo = _ref.useFooterLogo,
      onSuccess = _ref.onSuccess,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? defaultOnError : _ref$onError,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? 'production' : _ref$environment;
  var classes = useStyles();
  var links = (0, _constants.getLinksForEnv)(environment);
  var client = (0, _publicClient["default"])(environment);
  var onSuccessCallback = onSuccess;

  if (!onSuccessCallback) {
    onSuccessCallback = function onSuccessCallback() {
      return defaultOnSuccess(links);
    };
  }

  var _useQuery = (0, _client.useQuery)(_isTokenValid["default"], {
    variables: {
      token: claimToken
    },
    fetchPolicy: 'no-cache',
    client: client,
    skip: !claimToken
  }),
      loadingValidateToken = _useQuery.loading,
      tokenData = _useQuery.data;

  var tokenInfo = tokenData ? tokenData.is_token_valid : {};
  var isTokenOld = tokenInfo.valid === false && tokenInfo.has_attempts_left === true; // This is an edge case that _shouldn't_ happen in the happy path

  var isClaimedWithNoAccount = tokenInfo.claimed && false === tokenInfo.has_account;
  var needsNewToken = isTokenOld || isClaimedWithNoAccount;
  var isBorrowerEnrollment = mode === _constants.USER_SIGNUP_MODES.PARTNER_BORROWER_POST_INVITE_ENROLL;

  if (isBorrowerEnrollment && undefined === claimToken) {
    onError(_constants.ERROR_CODES.MISSING_TOKEN, links);
  }

  if (tokenInfo !== null && tokenInfo !== void 0 && tokenInfo.has_account) {
    onError(_constants.ERROR_CODES.HAS_ACCOUNT, links);
  }

  if (needsNewToken) {
    onError(_constants.ERROR_CODES.NEED_NEW_TOKEN, links);
  }

  var isLoggedIn = document.cookie.includes('earnup_id_token=');

  if (isLoggedIn) {
    onError(_constants.ERROR_CODES.IS_LOGGED_IN, links);
  }

  var loading = loadingValidateToken || tokenInfo.has_account || isTokenOld;

  var SignupFlow = function SignupFlow() {
    return isBorrowerEnrollment ? /*#__PURE__*/_react["default"].createElement(_BorrowerFlow["default"], {
      claimToken: claimToken,
      onSuccess: onSuccessCallback,
      links: links,
      client: client,
      isPartnerBorrower: isPartnerBorrower
    }) : /*#__PURE__*/_react["default"].createElement(_EnterpriseAgentFlow["default"], {
      claimToken: claimToken,
      onSuccess: onSuccessCallback,
      links: links,
      client: client
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_.LoadingGate, {
    condition: false === loading
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    className: classes.userSignUpFormRoot,
    container: true,
    alignContent: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_.Paper, {
    elevation: 2,
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    className: classes.innerPaperContainer
  }, /*#__PURE__*/_react["default"].createElement(SignupFlow, null))), /*#__PURE__*/_react["default"].createElement(_.LegalFooter, {
    links: links,
    useFooterLogo: useFooterLogo
  })));
};

UserSignUp.propTypes = {
  claimToken: _propTypes["default"].string,
  mode: _propTypes["default"].oneOf(Object.values(_constants.USER_SIGNUP_MODES)),
  environment: _propTypes["default"].string,
  onSuccess: _propTypes["default"].func,
  onError: _propTypes["default"].func
};
var _default = UserSignUp;
exports["default"] = _default;